// extracted by mini-css-extract-plugin
export default {"container":"Book_container__mYd+V","title":"Book_title__IF-FL","button":"Book_button__VN-xc"};